// extracted by mini-css-extract-plugin
module.exports = {"image":"styles-module--image--2cMCi","text":"styles-module--text--3ky49"};